import React from 'react';
import Navbar from './components/Nav';
import Main from './components/Main';
import Footer from './components/Footer';
import './App.css';

export default function App() {
  return (
    <>
      <Navbar/>
      <Main/>
      <Footer/>
    </>

    );
}

